export enum InfoTooltip {
    EnterpriseTerms = 'EnterpriseTerms',
    LaborProductivityTerms = 'LaborProductivityTerms',
}